"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRow = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Split_1 = require("../Split");
const MiniTitle_1 = require("../MiniTitle");
const use_t_1 = require("use-t");
const blockClass = (0, nano_theme_1.rule)({
    pd: 0,
    mr: 0,
    '&+&': {
        pd: '16px 0 0',
    },
});
const titleClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.theme.font.ui2.bold,
    fz: '14px',
    w: '100%',
    pd: '4px 0 10px',
    mr: 0,
});
const descriptionClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.theme.font.ui2.mid,
    fz: '12px',
    op: 0.75,
    w: '100%',
    pd: '8px 0 0',
    mr: 0,
});
const FormRow = ({ title, description, descriptionAbove, optional, right, children }) => {
    const [t] = (0, use_t_1.useT)();
    let titleElement = title;
    const descriptionElement = !!description && (React.createElement("div", { className: descriptionClass, style: {
            padding: descriptionAbove ? '0 0 8px' : right ? '0 8px 0 0' : void 0,
            marginTop: descriptionAbove ? '-8px' : void 0,
        } }, description));
    if (optional) {
        titleElement = (React.createElement(Split_1.Split, null,
            title,
            React.createElement(MiniTitle_1.MiniTitle, null, t('optional'))));
    }
    return (React.createElement("div", { className: blockClass },
        !!title && React.createElement("div", { className: titleClass }, titleElement),
        right ? (React.createElement(Split_1.Split, null,
            descriptionElement || React.createElement("div", null),
            children)) : descriptionAbove ? (React.createElement(React.Fragment, null,
            descriptionElement,
            children)) : (React.createElement(React.Fragment, null,
            children,
            descriptionElement))));
};
exports.FormRow = FormRow;
